export var PortFilterOptions;
(function (PortFilterOptions) {
    PortFilterOptions["all"] = "all";
    PortFilterOptions["configured"] = "configured";
    PortFilterOptions["unconfigured"] = "unconfigured";
})(PortFilterOptions || (PortFilterOptions = {}));
